import { render, staticRenderFns } from "./Stap.vue?vue&type=template&id=9b216a34&scoped=true&"
import script from "./Stap.vue?vue&type=script&lang=js&"
export * from "./Stap.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b216a34",
  null
  
)

export default component.exports